export default "__VITE_ASSET__e87acdd1__"